// extracted by css-extract-rspack-plugin
export default {"cls1":"BulkFollowSuggestion-cls1_waR","cls2":"BulkFollowSuggestion-cls2_hkk BulkFollowSuggestion-cls1_waR"};